import currency from 'currency.js';
import dayjs, { Dayjs } from 'dayjs';

import {
  EDiscountRulesTerminalType,
  EDiscountRulesType,
  TDiscountRules,
  TTariff,
} from '../types';

type FilterDiscountRulesParams = {
  discountRules: TDiscountRules[];
  orderDate: Dayjs;
  tripStartDate: Dayjs;
};

// Keep only the discount rules that match the specified conditions.
function filterDiscountRules({
  discountRules,
  orderDate,
  tripStartDate,
}: FilterDiscountRulesParams) {
  const result = discountRules.filter((discountRule) => {
    // Check if the terminal type is not web
    const isTerminalTypeInvalid =
      discountRule.terminalTypeId !== null &&
      discountRule.terminalTypeId !== EDiscountRulesTerminalType.web;

    // Check if the discount rule starts after the order date
    const isFromPayDateInvalid =
      discountRule.fromPayDate &&
      dayjs(discountRule.fromPayDate).isAfter(orderDate);

    // Check if the discount rule ends before the order date
    const isToPayDateInvalid =
      discountRule.toPayDate &&
      dayjs(discountRule.toPayDate).isBefore(orderDate);

    // Check if the discount rule starts after the trip start time
    const isFromTripDateInvalid =
      discountRule.fromTripDate &&
      dayjs(discountRule.fromTripDate).isAfter(tripStartDate);

    // Check if the discount rule ends before the trip start time
    const isToTripDateInvalid =
      discountRule.toTripDate &&
      dayjs(discountRule.toTripDate).isBefore(tripStartDate);

    // If some of condition is true, discount rule should be ignored
    const shouldSkipRule = [
      isTerminalTypeInvalid,
      isFromPayDateInvalid,
      isToPayDateInvalid,
      isFromTripDateInvalid,
      isToTripDateInvalid,
    ].some(Boolean);

    // ignore discount rule for Array.filter
    return !shouldSkipRule;
  });

  return result;
}

type CalculateTariffPriceParams = {
  baseTariffPrice: number;
  discountRules: TDiscountRules[];
};

function calculateTariffPrice({
  baseTariffPrice,
  discountRules,
}: CalculateTariffPriceParams) {
  // The base price of the tariff.
  // It will be adjusted depending on the type of tariff.
  let tariffPrice = currency(baseTariffPrice);
  console.log({ tariffPrice });

  for (const rule of discountRules) {
    console.log({ rule });
    // The value by which the final price of the tariff will change.
    // The operation with this number(addition or subtraction)
    // depends on the type of discount rule.
    let amount = currency(0);

    // Set tariff price, if discount rule is fix price.
    // Other variants should be ignored
    if (
      rule.type === EDiscountRulesType.fixPrice &&
      typeof rule?.amount === 'number'
    ) {
      tariffPrice = currency(rule.amount);

      break;
    }

    // Add the value to amount if it is specified in the discount rule
    if (typeof rule?.amount === 'number') {
      amount = amount.add(rule.amount);
    }

    // Add a percentage of the tariff price to amount if it is specified in the discount rule.
    if (typeof rule?.percent === 'number') {
      const discountPercent = tariffPrice.multiply(rule.percent).divide(100);

      amount = amount.add(discountPercent);
    }

    // Subtract calculated amount from `tariffPrice` for discount
    if (rule.type === EDiscountRulesType.discount) {
      const priceWithDiscount = tariffPrice.subtract(amount);

      console.log({ priceWithDiscount });
      tariffPrice = priceWithDiscount;
    }

    // Add calculated amount to `tariffPrice` for commission
    if (rule.type === EDiscountRulesType.commission) {
      const priceWithCommission = tariffPrice.add(amount);

      console.log({ priceWithCommission });
      tariffPrice = priceWithCommission;
    }

    console.log({ amount: amount.value });
  }

  return tariffPrice;
}

type CalcTariffPriceParams = {
  tariff: Pick<TTariff, 'price' | 'discountRules'>;
  tripStartTime: string;
  orderDate?: string;
};
export function calcTariffTotalPrice({
  tariff,
  tripStartTime,
  orderDate = new Date().toJSON(),
}: CalcTariffPriceParams) {
  if (!tariff.discountRules) return currency(tariff.price);

  const discountRules = filterDiscountRules({
    discountRules: tariff.discountRules,
    orderDate: dayjs(orderDate),
    tripStartDate: dayjs(tripStartTime),
  });

  console.log({ discountRules });

  const resultPrice = calculateTariffPrice({
    baseTariffPrice: tariff.price,
    discountRules,
  });

  console.log({ tariffPrice: tariff.price, resultPrice });

  return resultPrice;
}
